import { CHAPTERS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const Manifesto = () => {
  return (
    <section
      id="approach"
      data-testid="manifesto-section"
      className="relative overflow-hidden bg-[#141414] py-24 sm:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="mb-20 max-w-3xl">
          <Reveal
            as="p"
            y={20}
            className="mb-6 font-mono-accent text-xs uppercase tracking-[0.3em] text-yellow-400"
          >
            / The Therapy
          </Reveal>
          <Reveal
            as="h2"
            delay={80}
            className="font-display text-4xl uppercase leading-[0.95] text-white sm:text-6xl"
          >
            Structured Method.
            <span className="text-yellow-400"> Proven Results.</span>
          </Reveal>
        </div>

        <div className="divide-y divide-white/10 border-y border-white/10">
          {CHAPTERS.map((c, i) => (
            <Reveal
              key={c.num}
              delay={i * 90}
              data-testid={`chapter-${c.num}`}
              className="group grid grid-cols-1 gap-6 py-10 transition-colors duration-500 hover:bg-white/[0.02] md:grid-cols-12 md:items-center md:gap-10"
            >
              <div className="font-display text-7xl leading-none text-stroke transition-colors duration-500 group-hover:text-yellow-400 md:col-span-3 md:text-8xl">
                {c.num}
              </div>
              <h3 className="font-display text-4xl uppercase text-white md:col-span-3 md:text-5xl">
                {c.title}
              </h3>
              <p className="max-w-xl text-base leading-relaxed text-neutral-400 md:col-span-6">
                {c.body}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
